import { render, staticRenderFns } from "./AddFolders.vue?vue&type=template&id=3cb035ad&scoped=true&"
import script from "./AddFolders.vue?vue&type=script&lang=js&"
export * from "./AddFolders.vue?vue&type=script&lang=js&"
import style0 from "./AddFolders.vue?vue&type=style&index=0&id=3cb035ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb035ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb035ad')) {
      api.createRecord('3cb035ad', component.options)
    } else {
      api.reload('3cb035ad', component.options)
    }
    module.hot.accept("./AddFolders.vue?vue&type=template&id=3cb035ad&scoped=true&", function () {
      api.rerender('3cb035ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/greenFitOut/AddFolders.vue"
export default component.exports